var _path, _path2, _path3, _path4, _path5, _ellipse, _rect, _rect2, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06139 13.0677C4.06139 12.0368 4.89713 11.201 5.92806 11.201H44.6663C45.6972 11.201 46.5329 12.0368 46.5329 13.0677V42.0697C46.5329 43.1006 45.6972 43.9363 44.6663 43.9363H5.92806C4.89712 43.9363 4.06139 43.1006 4.06139 42.0697V13.0677Z",
    fill: "white",
    stroke: "#081E54",
    strokeWidth: 0.933333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3634 6C33.6211 6 33.8301 6.20893 33.8301 6.46667L33.8301 7.20245L16.9504 7.20245L16.9504 6.46667C16.9504 6.20893 17.1593 6 17.4171 6L33.3634 6Z",
    fill: "#081E54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8301 7.20364L33.8301 14.424L32.6244 14.424L32.6244 6.84375L33.8301 7.20364Z",
    fill: "#081E54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1553 6.99219L18.1553 13.6081L16.9496 13.6081L16.9496 6.99458L18.1553 6.99219Z",
    fill: "#081E54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59473 12.8823C3.59473 11.8514 4.43046 11.0156 5.46139 11.0156H44.466C44.9299 11.0156 45.3772 11.1884 45.7207 11.5002L45.9608 11.7181C46.3069 12.0324 46.5226 12.4651 46.565 12.9306L46.9996 17.6933H3.59473V12.8823Z",
    fill: "#B7CCFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.2963,
    cy: 29.964,
    rx: 8.43983,
    ry: 8.41715,
    fill: "#A020FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.3926,
    y: 26.3672,
    width: 1.80854,
    height: 7.2147,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9141,
    y: 29.0703,
    width: 1.80368,
    height: 7.23414,
    transform: "rotate(90 28.9141 29.0703)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06139 13.0677C4.06139 12.0368 4.89713 11.201 5.92806 11.201H44.6663C45.6972 11.201 46.5329 12.0368 46.5329 13.0677V42.0697C46.5329 43.1006 45.6972 43.9363 44.6663 43.9363H5.92806C4.89712 43.9363 4.06139 43.1006 4.06139 42.0697V13.0677Z",
    stroke: "#081E54",
    strokeWidth: 0.933333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.4b92f21c24d4e9a1eed5cb3225117471.svg";
export { ForwardRef as ReactComponent };